/**
 * SMSListContainer
 * --
 */
import React from 'react';
import SMSListPresenter from './SMSListPresenter';

const SMSListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SMSListPresenter />
    </>
  );
};

export default SMSListContainer;
